/**
 * used to transform the list of Saved Cards
 *
 * @param savedCardDTOList
 *
 * [ used primarily in ./paymentCreationInfoTransformer.js ]
 */

import { savedCardDtoTransformer } from './savedCardDtoTransformer';


export const savedCardDtoListTransformer = (savedCardDTOList: { length: any; map: (arg0: (savedCard: any) => any) => never[]; }) => {
  let transformedArray: never[] = [];
  if (!savedCardDTOList || !savedCardDTOList.length) {
    return transformedArray;
  }

  transformedArray = savedCardDTOList.map((savedCard: any) => savedCardDtoTransformer(savedCard));

  return transformedArray;
};
